import request from "../request";

export default {
  // 场景组-列表
  lists(data) {
    return request.get("/group/lists", data);
  },
	
	listsAll(data) {
		return request.get("/group/listsAll", data);
	},

  // 场景组-添加
  add(data) {
    return request.post("/group/add", data);
  },

  // 场景组-编辑
  edit(data) {
    return request.post("/group/edit", data);
  },

  // 场景组-删除
  delete(data) {
    return request.post("/group/delete", data);
  },

  // 场景组-排序
  sort(data) {
    return request.post("/group/sort", data);
  }
};
